export default __webpack_public_path__ + "static/media/hand-icon-color.743dde8d.svg";